/**
 * Clans jouables (V5 : livre de base, Players Guide, Cults of the Blood Gods).
 * Fléaux et compulsions : résumés courts rédigés pour l'app, pas le texte des livres.
 * `anyDisciplines` : le Caïtiff choisit librement ses disciplines.
 */

export const CLANS = [
  {
    id: 'brujah',
    name: {fr: 'Brujah', en: 'Brujah'},
    disciplines: ['celerity', 'potence', 'presence'],
    bane: {fr: 'Colère à fleur de peau : malus aux tests pour résister à la frénésie de fureur.', en: 'Short fuse: penalty to resist fury frenzy.'},
    compulsion: {fr: 'Rébellion : s\'opposer à l\'autorité ou à ce qu\'on attend de lui.', en: 'Rebellion: defy authority or expectations.'},
  },
  {
    id: 'gangrel',
    name: {fr: 'Gangrel', en: 'Gangrel'},
    disciplines: ['animalism', 'fortitude', 'protean'],
    bane: {fr: 'Traits bestiaux : la frénésie laisse des marques animales qui gênent.', en: 'Bestial features: frenzy leaves animal traits.'},
    compulsion: {fr: 'Sensibilité féroce : agir d\'instinct, par la force ou la fuite.', en: 'Feral impulses: act on instinct.'},
  },
  {
    id: 'malkavian',
    name: {fr: 'Malkavien', en: 'Malkavian'},
    disciplines: ['auspex', 'dominate', 'obfuscate'],
    bane: {fr: 'Fêlure : un trouble mental qui s\'aggrave sous la pression.', en: 'Fractured perspective: a mental affliction.'},
    compulsion: {fr: 'Délire : les perceptions se brouillent.', en: 'Delusion: perceptions blur.'},
  },
  {
    id: 'nosferatu',
    name: {fr: 'Nosferatu', en: 'Nosferatu'},
    disciplines: ['animalism', 'obfuscate', 'potence'],
    bane: {fr: 'Difformité : apparence monstrueuse, impossible de passer pour humain sans pouvoir.', en: 'Repulsiveness: monstrous appearance.'},
    compulsion: {fr: 'Cryptophilie : obsession pour les secrets.', en: 'Cryptophilia: obsession with secrets.'},
  },
  {
    id: 'toreador',
    name: {fr: 'Toréador', en: 'Toreador'},
    disciplines: ['auspex', 'celerity', 'presence'],
    bane: {fr: 'Esthète : la laideur alentour pénalise les actions.', en: 'Aesthetic fixation: ugliness hampers actions.'},
    compulsion: {fr: 'Obsession : fasciné par une chose belle.', en: 'Obsession: captivated by beauty.'},
  },
  {
    id: 'tremere',
    name: {fr: 'Tremere', en: 'Tremere'},
    disciplines: ['auspex', 'bloodSorcery', 'dominate'],
    bane: {fr: 'Sang déficient : liens de sang difficiles à imposer.', en: 'Deficient blood: blood bonds are harder to forge.'},
    compulsion: {fr: 'Perfectionnisme : rien n\'est jamais assez bien fait.', en: 'Perfectionism: nothing is good enough.'},
  },
  {
    id: 'ventrue',
    name: {fr: 'Ventrue', en: 'Ventrue'},
    disciplines: ['dominate', 'fortitude', 'presence'],
    bane: {fr: 'Palais raffiné : ne peut se nourrir que d\'un type précis de proie.', en: 'Rarefied tastes: can only feed on a specific prey.'},
    compulsion: {fr: 'Arrogance : exiger l\'obéissance.', en: 'Arrogance: demand obedience.'},
  },
  {
    id: 'banuHaqim',
    name: {fr: 'Banu Haqim', en: 'Banu Haqim'},
    disciplines: ['bloodSorcery', 'celerity', 'obfuscate'],
    bane: {fr: 'Soif de sang caïnite : se nourrir de vampires est difficile à arrêter.', en: 'Blood addiction: hard to stop feeding on Kindred.'},
    compulsion: {fr: 'Jugement : punir celui qui a fauté.', en: 'Judgment: punish wrongdoers.'},
  },
  {
    id: 'hecata',
    name: {fr: 'Hecata', en: 'Hecata'},
    disciplines: ['auspex', 'fortitude', 'oblivion'],
    bane: {fr: 'Baiser douloureux : leur morsure fait souffrir au lieu de charmer.', en: 'Painful kiss: their bite hurts.'},
    compulsion: {fr: 'Morbidité : fascination pour la mort.', en: 'Morbidity: fascination with death.'},
  },
  {
    id: 'lasombra',
    name: {fr: 'Lasombra', en: 'Lasombra'},
    disciplines: ['dominate', 'oblivion', 'potence'],
    bane: {fr: 'Reflets distordus : invisibles aux miroirs et mal perçus par la technologie.', en: 'Distorted image: trouble with mirrors and technology.'},
    compulsion: {fr: 'Ambition : chercher à prendre l\'ascendant.', en: 'Ruthlessness: seek the upper hand.'},
  },
  {
    id: 'ministry',
    name: {fr: 'Ministère', en: 'The Ministry'},
    disciplines: ['obfuscate', 'presence', 'protean'],
    bane: {fr: 'Craint la lumière : les lumières vives pénalisent.', en: 'Abhors the light: bright light hampers.'},
    compulsion: {fr: 'Transgression : pousser autrui à franchir une limite.', en: 'Transgression: tempt others to cross a line.'},
  },
  {
    id: 'ravnos',
    name: {fr: 'Ravnos', en: 'Ravnos'},
    disciplines: ['animalism', 'obfuscate', 'presence'],
    bane: {fr: 'Condamné à errer : dormir au même endroit attire le feu.', en: 'Doomed to roam: resting in the same place is dangerous.'},
    compulsion: {fr: 'Témérité : prendre des risques inutiles.', en: 'Tempting fate: take needless risks.'},
  },
  {
    id: 'salubri',
    name: {fr: 'Salubri', en: 'Salubri'},
    disciplines: ['auspex', 'dominate', 'fortitude'],
    bane: {fr: 'Proie convoitée : leur sang attire les autres vampires ; troisième œil.', en: 'Hunted: their blood tempts other Kindred.'},
    compulsion: {fr: 'Empathie affective : ressentir et soulager la souffrance d\'autrui.', en: 'Affective empathy: ease others\' suffering.'},
  },
  {
    id: 'tzimisce',
    name: {fr: 'Tzimisce', en: 'Tzimisce'},
    disciplines: ['animalism', 'dominate', 'protean'],
    bane: {fr: 'Attachement : doit dormir au contact de ce qu\'il possède.', en: 'Grounded: must rest with a chosen charge.'},
    compulsion: {fr: 'Possessivité : vouloir contrôler ce qui l\'entoure.', en: 'Covetousness: need to possess.'},
  },
  {
    id: 'caitiff',
    name: {fr: 'Caïtiff', en: 'Caitiff'},
    disciplines: [],
    anyDisciplines: true,
    bane: {fr: 'Sans clan : méprisés, et les disciplines coûtent plus cher en XP.', en: 'Outcast: scorned, disciplines cost more XP.'},
    compulsion: null,
  },
  {
    id: 'thinBlood',
    name: {fr: 'Sang-Clair', en: 'Thin-blood'},
    disciplines: ['thinBloodAlchemy'],
    thinBlood: true,
    bane: {fr: 'Sang trop clair : pas de fléau de clan, mais avantages et handicaps propres aux Sang-Clair.', en: 'Too thin: no clan bane, but thin-blood merits and flaws.'},
    compulsion: null,
  },
];

export const CLAN_IDS = CLANS.map(clan => clan.id);
export const CLANS_BY_ID = CLANS.reduce((acc, clan) => ({...acc, [clan.id]: clan}), {});
